import { render, staticRenderFns } from "./HeaderSubstitutions.vue?vue&type=template&id=75ef76ee&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75ef76ee')) {
      api.createRecord('75ef76ee', component.options)
    } else {
      api.reload('75ef76ee', component.options)
    }
    module.hot.accept("./HeaderSubstitutions.vue?vue&type=template&id=75ef76ee&", function () {
      api.rerender('75ef76ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/substitutions/HeaderSubstitutions.vue"
export default component.exports